import { render, staticRenderFns } from "./SelectContact.vue?vue&type=template&id=2b4e84bb"
import script from "./SelectContact.vue?vue&type=script&lang=js"
export * from "./SelectContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SelectContact.vue?vue&type=custom&index=0&blockType=stype&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports